<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import { faAdd, faEdit, faSave, faAngleLeft, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import { DeviceEntity } from '../../../modules/usersApi/devices/device.entity'
    import Fa from 'svelte-fa'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZinputBreak from '../../_common/z/zinput-break.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    // ##############################################################################################################

    let entity: DeviceEntity = new DeviceEntity()

    let webhookUrl: string = ''
    let webhookParam: string = ''
    let webhookEvents: string[] = []
    let eventTypes: { label: string; value: string }[] = []
    async function loadWebhook() {
        await loadEventTypes()
        webhookUrl = window.configs?.webhookUrl
        webhookParam = window.configs?.webhookParam
        webhookEvents = window.configs?.webhookEvents
        console.log('webhookEvents', webhookEvents)
    }
    async function loadEventTypes() {
        const result: string[] = await window.api.events.events.getEventTypes()
        eventTypes = []
        for (const et of result) {
            eventTypes.push({ value: et, label: et })
        }
    }

    async function saveWebhook() {
        if (!!webhookUrl && !webhookUrl.startsWith('http://') && !webhookUrl.startsWith('https://')) {
            window.error('A URL do webhook deve ser uma URL válida')
            return
        }
        await window.api.events.settings.updateConfigs({ webhookUrl, webhookParam, webhookEvents })
        window.alert('Configurações salvas')
    }

    async function loadEntities() {
        try {
            show = true
            entities = await window.api.users.devices.getAll()
            entities = await window.api.utils.utils.assignUsersFromObject(entities, undefined, 'userId')
            entities = await window.api.utils.utils.assignUsersFromObject(entities, undefined, 'lastUserId', 'lastUser')
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity(deviceId) {
        if (!deviceId) return
        if (!confirm('Deseja mesmo excluir este dispositivo?\nImportante: o usuário conectado será desconectado.')) {
            return
        }
        try {
            show = true
            await window.api.users.devices.remove(deviceId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    function goShowNewEntity() {
        entity = new DeviceEntity()
        step = 2
    }

    let show = false
    let step = 1
    let entities: DeviceEntity[] = []

    onMount(async () => {
        await loadWebhook()
        await loadEntities()
        step = 1
    })

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Dispositivos e APIs'
        grid.subtitle = ''
        grid.fontSize = '13px'
        grid.showActs = false
        grid.acts = [new GridButton({ callback: goShowNewEntity, icon: faAdd, color: 'green', label: 'Novo token' })]
        grid.cols.push(new GridCol({ content: 'Rótulo' }))
        grid.cols.push(new GridCol({ content: 'Descrição' }))
        grid.cols.push(new GridCol({ content: 'Token' }))
        // grid.cols.push(new GridCol({ content: 'Criado por' }))
        grid.cols.push(new GridCol({ content: 'Criado em', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Usuário' }))
        grid.cols.push(new GridCol({ content: 'Último acesso', type: GridColTypeEnum.datetime_friendly }))
        //grid.cols.push(new GridCol({ content: 'Requisições', type: GridColTypeEnum.int })) // por ora não faz sentido pois o controle de requisições é apenas por token, mas ainda não está implementado
        if (window.store.token.permissions.account.devices.write) {
            grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        }
        // grid lines
        const localDeviceId = window.api.users.devices.getDeviceId()
        for (const item of entities) {
            const btnRemove = new GridButton({
                callback: () => removeEntity(item.deviceId),
                color: 'yellow',
                icon: faTrashAlt,
            })
            const btnEdit = new GridButton({
                callback: () => editEntity(item.deviceId),
                icon: faEdit,
            })
            let line: GridLine = new GridLine()
            line.slots.push({
                content: item.label || '-',
                badge: localDeviceId === item.deviceId ? new GridBadge({ label: 'este', class: GridBadgeClassEnum.badge_success }) : undefined,
            })
            line.slots.push({ content: item.description || '-' })
            line.slots.push({ content: item.token || '-' })
            // line.slots.push({ content: item.user?.userName })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.lastUser?.userName })
            line.slots.push({ content: item.lastRequestAt })
            //line.slots.push({ content: item.requestCount })
            if (window.store.token.permissions.account.devices.write) {
                line.slots.push({ content: [btnRemove, btnEdit] })
            }

            grid.lines.push(line)
        }
    }

    async function editEntity(entityId) {
        entity = await window.api.users.devices.getOne(entityId)
        console.log('device', entity)
        step = 2
    }

    async function saveEntity() {
        if (!entity.deviceId) {
            await createEntity()
        } else {
            await updateEntity()
        }
    }

    async function createEntity() {
        try {
            if (!entity.label) {
                alert('Preencha o rótulo')
                return
            }
            show = true
            entity = await window.api.users.devices.create({
                label: entity.label,
            })
            await loadEntities()
            step = 3
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            if (!entity.label) {
                alert('Preencha o rótulo')
                return
            }
            show = true
            await window.api.users.devices.update(entity.deviceId, {
                label: entity.label,
            })
            await loadEntities()
            step = 1
        } catch (error) {
        } finally {
            show = false
        }
    }
</script>

{#if step === 1}
    <Content footer={true}>
        <Zframe title="API" headline="O Zandu possui API aberta para integração com outras ferramentas.">
            Parar gerar um token de acesso para a API utilize a opção "Novo Token" nesta página.<br />
            Para acessar a documentação visite: <a class="btn btn-link" href="https://api.zandu.com.br/doc" target="_blank">https://api.zandu.com.br/docs</a>
        </Zframe>
        <Zframe class="h-space" title="Webhook" headline="Configure o webhook para receber eventos ocorridos no Zandu.">
            <ZContainer>
                <Zinput
                    type="text"
                    size={3}
                    label="URL do Webhook"
                    help="Enviaremos um JSON via método POST para a URL informada aqui. Lembre-se: o Zandu envia webhooks apenas para uma URL. Caso mude a URL, a anterior não será mais chamada."
                    bind:value={webhookUrl}
                ></Zinput>
                <Zinput
                    type="text"
                    size={2}
                    label="Parâmetro"
                    bind:value={webhookParam}
                    help="Informação personalizada de sua escolha. Por exemplo, o ID de seu cliente dentro de sua plataforma. O valor deste campo será enviado na raíz do JSON dentro do atributo 'param'."
                ></Zinput>
                <Zinput label="Eventos a serem enviados" size={7} type="multiselect" options={eventTypes} bind:value={webhookEvents}></Zinput>
                <Zbutton label="Salvar" on:click={saveWebhook}></Zbutton>
            </ZContainer>
            <div class="alert alert-warning mt-3">Atenção: alterações no webhook podem levar até 10 minutos para surtirem efeito.</div>
        </Zframe>
        <Zgrid class="h-space" {grid} />
        <LoadSpinner {show} />
    </Content>
{/if}

{#if step === 2}
    <Content>
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            <div class="spacer" />
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>
        <Zframe class="mt-3" title="Dados do acesso">
            <Zinput size={4} label="Nome para este acesso" bind:value={entity.label}></Zinput>
        </Zframe>
    </Content>
{/if}

{#if step === 3}
    <Content>
        <Zact>
            <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
        </Zact>
        <Zframe class="mt-3" title="Token de acesso">
            <ZContainer>
                <Zinput size={4} label="Nome" disabled={true} help="" bind:value={entity.label}></Zinput>
                <Zinput size={4} label="Token" showCopy={true} disabled={true} help="" bind:value={entity.token}></Zinput>
                <ZinputBreak></ZinputBreak>
                <ZContainerCol size={12}>
                    <div class="alert alert-light text-center">
                        Atenção: copie seu token de acesso.<br />
                        Por questões de segurança ele não será mais exibido no futuro.
                    </div>
                </ZContainerCol>
            </ZContainer>
        </Zframe>
    </Content>
{/if}

<style>
</style>
